/* eslint-disable */
import { useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'

import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import useAuth from '../../hooks/useAuth'
import OHASession from './OHASession'
import Session from './Session'

const ClientSession = () => {
  const axios = useAxiosPrivate()

  const { clientId, claimId, sessionId } = useParams()
  const { setShowLoader } = useAuth()

  const [clientData, setClientData] = useState({
    name: '',
    reference: '',
  })

  const [claimData, setClaimData] = useState({
    reference: '',
    external_reference: '',
  })

  const [sessionData, setSessionData] = useState({ notes: '' })

  useEffect(() => {
    getSessionById()
  }, [])

  const getSessionById = async () => {
    setShowLoader(true)
    try {
      const response = await axios.get(
        `/clients/${clientId}/claims/${claimId}/sessions/${sessionId}`
      )
      setClientData(
        response.data.result.claim_relationship[0].client_relationship
      )
      setClaimData(response.data.result.claim_relationship[0])
      setSessionData(response.data.result)
    } catch (error) {
      console.error(error)
    }
    setShowLoader(false)
  }

  const useOHASession = [23, 24, 25].includes(sessionData?.serviceId)

  const sessionProps = {
    clientData,
    claimData,
    sessionData,
  }

  return useOHASession ? <OHASession {...sessionProps} /> : <Session {...sessionProps} />
}

export default ClientSession
